/*
 * @Author: jerryfwang
 * @Date: 2019-09-12 12:23:10
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-12-18 10:46:10
 */
/*
 * @Author: jerryfwang
 * @Date: 2019-09-10 17:42:14
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-09-12 11:58:27
 */
import React from 'react';
import './footer.scss';
type Props = {
  value: Object,
};
export default class Rumor extends React.Component<Props> {
  render() {
    const { value } = this.props;
    if (!value) {
      return null;
    }
    const { reference = [] } = value || {};
    return (
      <div className="rumor_footer_content">
        {reference.map((elem, index) => (
          <div key={index} className="reference">
            {elem}
          </div>
        ))}
      </div>
    );
  }
}
